import * as v from "valibot";
import { rpcContract } from "../rpc";
import { linkAttachmentSchema } from "./update-live-event";

export const publishDraftLiveEventRpcContract = rpcContract({
  name: "publish-draft-live-event",
  paramsSchema: v.object({
    event_id: v.string(),
    title: v.pipe(
      v.string(),
      v.minLength(1, "Title is required"),
      v.maxLength(255, "Title must be less than 255 characters"),
    ),
    description: v.optional(v.pipe(v.string(), v.maxLength(750, "Description must be less than 750 characters"))),
    content_tier: v.picklist(["free", "premium"], "Content tier must be free or premium"),
    fee_cents: v.optional(
      v.pipe(v.number(), v.minValue(50, "Fee must be at least €0.50"), v.maxValue(99900, "Fee cannot exceed €999")),
    ),
    scheduled_start_time: v.pipe(v.string(), v.isoTimestamp("Invalid date format")),
    max_attendees: v.optional(
      v.pipe(
        v.number(),
        v.minValue(1, "Max attendees must be at least 1"),
        v.maxValue(10000, "Max attendees cannot exceed 10,000"),
      ),
    ),
    thumbnail_file_id: v.optional(v.string()),
    whatsapp_url: v.optional(v.string()),
    cta_text: v.optional(v.pipe(v.string(), v.maxLength(255, "CTA text must be less than 255 characters"))),
    language: v.optional(v.pipe(v.string(), v.maxLength(10, "Language code must be less than 10 characters"))),
    stream_delivery: v.optional(v.picklist(["browser", "obs"])),
    expected_duration: v.optional(
      v.pipe(
        v.number(),
        v.minValue(1, "Duration must be at least 1 minute"),
        v.maxValue(1440, "Duration cannot exceed 24 hours"),
      ),
    ),
    link_attachments: v.optional(v.nullable(v.array(linkAttachmentSchema))),
    community_only: v.optional(v.boolean()),
    community_ids: v.optional(v.array(v.string())),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    event: v.optional(
      v.object({
        id: v.string(),
        title: v.string(),
        description: v.nullable(v.string()),
        content_tier: v.string(),
        fee_cents: v.nullable(v.number()),
        status: v.string(),
        scheduled_start_time: v.nullable(v.string()),
        max_attendees: v.nullable(v.number()),
        thumbnail_url: v.nullable(v.string()),
        created_at: v.string(),
        expected_duration: v.nullable(v.number()),
      }),
    ),
    message: v.optional(v.string()),
  }),
});

export type PublishDraftLiveEventParams = v.InferOutput<(typeof publishDraftLiveEventRpcContract)["paramsSchema"]>;
export type PublishDraftLiveEventResult = v.InferOutput<(typeof publishDraftLiveEventRpcContract)["resultSchema"]>;
